// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoSearchDialog from "./../../factories/bao-search-dialog";
import "./../../bindings/foreach-selection";
function ExplorerFilterTypeDetailTable(parent) {
    var self = this;
    self.Bao = Bao;
    self.ColumnName = ko.observable("");
    self.SelectedDetailsRow = ko.observable();
    self.ToolbarButtons = ko.observableArray();
    self.DetailCollection = ko.observableArray();
    self.SearchType = ko.observable();
    self.CustomFilter = ko.observable();
    self.SelectedValue = ko.observable();
    self.SelectedObjectId = ko.observable();
    self.SelectedItem = ko.observableArray();
    self.ObjectValue = ko.observable();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedDetailsRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedItem.subscribe(function (newValue) {
        if (newValue != null && newValue.length > 0 && self.ObjectValue() != null) {
            var tempArray = [];
            for (var i = 0; i < newValue.length; i++) {
                tempArray[i] = {
                    Key: newValue[i].PrimaryKeyValue,
                    Value: newValue[i][self.ObjectValue()]
                };
            }
            self.AddToSession(tempArray);
        }
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "actionFilterDefinitionDetailAdd":
                self.Add();
                break;
            case "actionFilterDefinitionDetailRemove":
                self.Remove();
                break;
        }
    };
    self.Add = function () {
        self.SelectedItem([]);
        var searchDialog = new baoSearchDialog();
        searchDialog.InitSearcher({
            SearchType: self.SearchType(),
            AutoSearch: true,
            MultiSelect: true,
            ObjectId: self.SelectedObjectId,
            ObjectValue: "PrimaryKeyValue",
            CustomFilter: self.CustomFilter(),
            SelectedItem: self.SelectedItem,
            ApplyItemCallback: function (searchVM) {
                self.AddToSession(searchVM.Selection());
            },
            ShowBadges: false
        });
    };
    self.Remove = function () {
        parent.DirtyFlag(true);
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/RemoveExplorerFilterDefinitionDataSourceDetail", JSON.stringify({
            id: self.SelectedDetailsRow().ObjectId,
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.Refresh();
        });
    };
    self.AddToSession = function (selectedItems) {
        parent.DirtyFlag(true);
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/AddExplorerFilterDefinitionDataSourceDetail", JSON.stringify({
            selectedItems: ko.map.toJS(selectedItems).map(function (item) {
                return {
                    Key: item.PrimaryKeyValue,
                    Value: item.TabName
                };
            }),
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.Refresh();
        });
    };
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "actionFilterDefinitionDetailRemove":
                    button.Enabled(self.SelectedDetailsRow() != null);
                    break;
            }
        });
    };
    self.Refresh = function () {
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/GetExplorerFilterDefinitionDataSource", JSON.stringify({
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            explorerFilterId: parent.ExplorerFilterId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function (result) {
            if (result != null && result.Model != null) {
                self.DetailCollection(result.Model.DetailCollectionFiltered);
            }
            parent.TabPage.IsLoading(false);
        });
    };
    self.loaded = function () {
        if (parent != null && parent.ExplorerFilterDefinitionDataSource() != null) {
            var dataSource = parent.ExplorerFilterDefinitionDataSource();
            self.DetailCollection(dataSource.DetailCollectionFiltered);
            self.SearchType(dataSource.SearchType);
            self.ColumnName(dataSource.ColumnName);
            self.ObjectValue(dataSource.ObjectValue);
            if (dataSource.CustomFilter != null) {
                var stringKey = dataSource.CustomFilter[0].Key.toString();
                var objectFilter = {};
                objectFilter[stringKey] = dataSource.CustomFilter[0].Value;
                self.CustomFilter(objectFilter);
            }
        }
    };
}
export default ExplorerFilterTypeDetailTable;